/** Alphabetical NHL teams for the 2026-2027 Prospect Preview series. */
const PROSPECT_PREVIEW_TEAMS = [
    { id: 'anaheim_ducks', name: 'Anaheim Ducks', abbr: 'ANA', color: '#f47a38' },
    { id: 'boston_bruins', name: 'Boston Bruins', abbr: 'BOS', color: '#fcb514' },
    { id: 'buffalo_sabres', name: 'Buffalo Sabres', abbr: 'BUF', color: '#002654' },
    { id: 'calgary_flames', name: 'Calgary Flames', abbr: 'CGY', color: '#cf4521' },
    { id: 'carolina_hurricanes', name: 'Carolina Hurricanes', abbr: 'CAR', color: '#cc0000' },
    { id: 'chicago_blackhawks', name: 'Chicago Blackhawks', abbr: 'CHI', color: '#cf0a2c' },
    { id: 'colorado_avalanche', name: 'Colorado Avalanche', abbr: 'COL', color: '#6f263d' },
    { id: 'columbus_blue_jackets', name: 'Columbus Blue Jackets', abbr: 'CBJ', color: '#002654' },
    { id: 'dallas_stars', name: 'Dallas Stars', abbr: 'DAL', color: '#006847' },
    { id: 'detroit_red_wings', name: 'Detroit Red Wings', abbr: 'DET', color: '#ce1126' },
    { id: 'edmonton_oilers', name: 'Edmonton Oilers', abbr: 'EDM', color: '#041e42' },
    { id: 'florida_panthers', name: 'Florida Panthers', abbr: 'FLA', color: '#041e42' },
    { id: 'los_angeles_kings', name: 'Los Angeles Kings', abbr: 'LAK', color: '#111111' },
    { id: 'minnesota_wild', name: 'Minnesota Wild', abbr: 'MIN', color: '#154734' },
    { id: 'montreal_canadiens', name: 'Montreal Canadiens', abbr: 'MTL', color: '#af1e2d' },
    { id: 'nashville_predators', name: 'Nashville Predators', abbr: 'NSH', color: '#ffb81c' },
    { id: 'new_jersey_devils', name: 'New Jersey Devils', abbr: 'NJD', color: '#ce1126' },
    { id: 'new_york_islanders', name: 'New York Islanders', abbr: 'NYI', color: '#00539b' },
    { id: 'new_york_rangers', name: 'New York Rangers', abbr: 'NYR', color: '#0038a8' },
    { id: 'ottawa_senators', name: 'Ottawa Senators', abbr: 'OTT', color: '#e31837' },
    { id: 'philadelphia_flyers', name: 'Philadelphia Flyers', abbr: 'PHI', color: '#f74902' },
    { id: 'pittsburgh_penguins', name: 'Pittsburgh Penguins', abbr: 'PIT', color: '#000000' },
    { id: 'san_jose_sharks', name: 'San Jose Sharks', abbr: 'SJS', color: '#006d75' },
    { id: 'seattle_kraken', name: 'Seattle Kraken', abbr: 'SEA', color: '#005bea' },
    { id: 'st_louis_blues', name: 'St. Louis Blues', abbr: 'STL', color: '#002f87' },
    { id: 'tampa_bay_lightning', name: 'Tampa Bay Lightning', abbr: 'TBL', color: '#002868' },
    { id: 'toronto_maple_leafs', name: 'Toronto Maple Leafs', abbr: 'TOR', color: '#00205b' },
    { id: 'utah_mammoth', name: 'Utah Mammoth', abbr: 'UTA', color: '#69b3e7' },
    { id: 'vancouver_canucks', name: 'Vancouver Canucks', abbr: 'VAN', color: '#00205b' },
    { id: 'vegas_golden_knights', name: 'Vegas Golden Knights', abbr: 'VGK', color: '#b4975a' },
    { id: 'washington_capitals', name: 'Washington Capitals', abbr: 'WSH', color: '#041e42' },
    { id: 'winnipeg_jets', name: 'Winnipeg Jets', abbr: 'WPG', color: '#041e42' },
];

/** One team per day starting August 1, 2026 (alphabetical). */
function getTeamReleaseDate(alphabeticalIndex) {
    return new Date(2026, 7, alphabeticalIndex + 1);
}

function startOfLocalDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function isTeamPreviewAvailable(alphabeticalIndex, now = new Date()) {
    return startOfLocalDay(now) >= startOfLocalDay(getTeamReleaseDate(alphabeticalIndex));
}

function formatReleaseLabel(date) {
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}

function nhlTeamLogoUrl(abbr) {
    return `https://assets.nhle.com/logos/nhl/svg/${abbr}_dark.svg`;
}

function getProspectPreviewTeam(teamId) {
    return PROSPECT_PREVIEW_TEAMS.find((team) => team.id === teamId) || null;
}

function getProspectPreviewTeamIndex(teamId) {
    return PROSPECT_PREVIEW_TEAMS.findIndex((team) => team.id === teamId);
}

export {
    PROSPECT_PREVIEW_TEAMS,
    getTeamReleaseDate,
    isTeamPreviewAvailable,
    formatReleaseLabel,
    nhlTeamLogoUrl,
    getProspectPreviewTeam,
    getProspectPreviewTeamIndex,
};
